import { useState } from 'react';
import { faqItems } from '@/mocks/faq';
import { companyInfo } from '@/mocks/company';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const whatsappMessage = encodeURIComponent('Olá! Estou no site da Maquinasdesoldageomembrana.com.br e gostaria de informações sobre máquinas de solda de geomembrana.');
  const whatsappUrl = `https://wa.me/${companyInfo.whatsapp}?text=${whatsappMessage}`;

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-16">
          <div className="lg:col-span-2">
            <span className="text-primary-500 text-xs uppercase tracking-widest mb-3 block">Perguntas Frequentes</span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 uppercase leading-tight mb-5">
              Tudo que<br /><span className="text-primary-500">Você Precisa</span><br />Saber
            </h2>
            <p className="text-foreground-500 text-sm leading-relaxed mb-6">Respondemos as principais dúvidas sobre máquinas de solda geomembrana, técnicas de soldagem e nossos equipamentos.</p>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold text-sm px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide"
            >
              <i className="ri-whatsapp-line" />
              Falar com Especialista
            </a>
            <div className="mt-8 grid grid-cols-2 gap-3">
              {[
                { icon: 'ri-shield-check-line', label: '+10 Anos', sub: 'de experiência' },
                { icon: 'ri-global-line', label: 'Brasil', sub: 'Atendimento Nacional' },
                { icon: 'ri-tools-line', label: 'Suporte', sub: 'técnico oficial' },
                { icon: 'ri-award-line', label: 'Garantia', sub: 'certificada' },
              ].map((stat) => (
                <div key={stat.label} className="flex items-center gap-2 p-3 bg-background-100 rounded-xl border border-background-200/50">
                  <div className="w-8 h-8 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                    <i className={`${stat.icon} text-primary-600 text-sm`} />
                  </div>
                  <div>
                    <p className="text-foreground-900 text-xs font-bold uppercase">{stat.label}</p>
                    <p className="text-foreground-400 text-[10px]">{stat.sub}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="bg-white rounded-2xl border border-background-200/70 px-4 md:px-6 divide-y divide-background-200/50">
              {faqItems.map((item, index) => (
                <div key={index} className="border-b border-background-200/50 last:border-0">
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    className="w-full flex items-center justify-between gap-4 py-5 text-left cursor-pointer group"
                    aria-expanded={openIndex === index}
                  >
                    <h4 className="text-foreground-900 text-sm font-bold uppercase leading-snug group-hover:text-primary-600 transition-colors">{item.question}</h4>
                    <div className={`w-7 h-7 flex items-center justify-center rounded-full border-2 flex-shrink-0 transition-all duration-300 ${openIndex === index ? 'border-primary-500 bg-primary-500 text-white rotate-45' : 'border-background-300 text-foreground-400'}`}>
                      <i className="ri-add-line text-sm" />
                    </div>
                  </button>
                  <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96 pb-5' : 'max-h-0'}`}>
                    <p className="text-foreground-600 text-sm leading-relaxed">{item.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}